import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"PT_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"variable\":\"--font-body\"}],\"variableName\":\"fontBody\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--font-headline\"}],\"variableName\":\"fontHeadline\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/layout/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTopButton"] */ "/vercel/path0/src/components/shared/back-to-top-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientChatbot"] */ "/vercel/path0/src/components/shared/client-chatbot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/vercel/path0/src/components/shared/google-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnboardingGreeting"] */ "/vercel/path0/src/components/shared/onboarding-greeting.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Preloader"] */ "/vercel/path0/src/components/shared/preloader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFeedback"] */ "/vercel/path0/src/components/shared/site-feedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteTour"] */ "/vercel/path0/src/components/shared/site-tour.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/src/components/ui/toaster.tsx");
